import PageLayout, { Section } from "./PageLayout";

export default function Terms() {
  return (
    <PageLayout
      eyebrow="Legal"
      title="Terms of Service"
      subtitle="Last updated: February 8, 2026"
    >
      <Section title="1. Acceptance of terms">
        <p>By creating an account or using Djino Stream ("the Service"), you agree to these Terms of Service and our Privacy Policy. If you do not agree, do not use the Service.</p>
      </Section>

      <Section title="2. The service">
        <p>Djino Stream is a subscription-based and ad-supported streaming service offering on-demand films, series and live television channels. Content availability and quality may vary by region, plan and device.</p>
      </Section>

      <Section title="3. Eligibility & accounts">
        <p>You must be at least 18 years old (or the age of majority in your jurisdiction) to create an account. You're responsible for keeping your password secure and for all activity on your account. Notify us immediately at <a className="text-[#E50914]" href="mailto:support@djinostream.com">support@djinostream.com</a> if you suspect unauthorized access.</p>
      </Section>

      <Section title="4. Subscriptions & billing">
        <p>Plans renew automatically each month at the price shown at sign-up unless you cancel before the end of the billing period. Free trials require valid PayPal authorization; you may cancel any time during the trial to avoid being charged. We may change pricing with 30 days' notice.</p>
        <p>Refunds: full refunds are available within 7 days of first payment if no content has been watched. Otherwise, payments are non-refundable.</p>
      </Section>

      <Section title="5. Acceptable use">
        <p>You agree NOT to:</p>
        <ul className="list-disc pl-5 space-y-1 text-[#bbb]">
          <li>Share your account credentials with anyone outside your household.</li>
          <li>Re-distribute, re-broadcast, screen-record or commercially exploit any content.</li>
          <li>Reverse-engineer, scrape, or interfere with the Service's security or DRM.</li>
          <li>Use the Service for any unlawful purpose.</li>
        </ul>
        <p>Violation may result in immediate account termination without refund.</p>
      </Section>

      <Section title="6. Intellectual property">
        <p>All content on Djino Stream is owned or licensed by us and protected by copyright, trademark and other laws. The Djino Stream name, logo and look are our trademarks.</p>
      </Section>

      <Section title="7. Disclaimers & liability">
        <p>The Service is provided "as is." To the maximum extent permitted by law, Djino Stream disclaims all warranties and is not liable for indirect or consequential damages arising from your use of the Service.</p>
      </Section>

      <Section title="8. Changes to terms">
        <p>We may update these Terms from time to time. Material changes will be communicated via email or in-app notification. Continued use after changes constitutes acceptance.</p>
      </Section>

      <Section title="9. Contact">
        <p>Questions? Reach us at <a className="text-[#E50914]" href="mailto:legal@djinostream.com">legal@djinostream.com</a> or write to Djino Stream, Boulevard du 30 Juin, Kinshasa, DRC.</p>
      </Section>
    </PageLayout>
  );
}
